<template>
  <div>
    <Card class="p-no-shadow-app">
      <template #title>Informação do Cliente</template>
      <template #content>
        <div class="p-grid">
          <div class="p-col-12 p-md-4">
            <p><strong>Nome:</strong> {{ clientInfo?.name }}</p>
            <p><strong>Morada:</strong> {{ clientInfo?.address }}</p>
            <p><strong>Código Postal:</strong> {{ clientInfo?.zipCode }}</p>
            <p><strong>Localidade:</strong> {{ clientInfo?.city }}</p>
            <p><strong>NIF:</strong> {{ clientInfo?.fiscalNumber }}</p>
          </div>
          <div class="p-col-12 p-md-4">
            <p><strong>Telefone:</strong> {{ clientInfo?.telephone }}</p>
            <p><strong>Telemóvel:</strong> {{ clientInfo?.mobilPhone }}</p>
            <p><strong>Email:</strong> {{ clientInfo?.email }}</p>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
export default {
  name: "ClientInfo",
  props: {
    patId: {
      type: Number,
      required: true,
    },
    clientInfo: {
      type: Object,
      required: false,
    },
  },
  components: {},
  data() {
    return {
      loading: false,
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
